module.exports = __webpack_public_path__ + "img/th-large-solid.7171a12c.svg";